import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';

export function FaqSection({
  items,
  className,
}: {
  items: { question: string; answer: { type: string; content: string | React.ReactNode }[] }[];
  className?: string;
}) {
  if (!items) {
    return null;
  }

  return (
    <section className={className} id="faq">
      <Accordion type="multiple" className="w-full">
        {items.map((item, index) => {
          return (
            <AccordionItem
              style={{ boxShadow: '0px 7px 15px 1px rgba(42,42,42,0.08)' }}
              key={index}
              value={`faq-item-${index}`}
              className="mb-[1.75vw] rounded-lg bg-white max-md:mb-[10px] max-md:border-2 max-md:border-[#AFAFAF] last:max-md:mb-0"
            >
              <AccordionTrigger className="text-left">{item.question}</AccordionTrigger>
              <AccordionContent>
                <div className="w-full bg-[#F2F2F2] p-[1.8vw]">
                  {item.answer.map((answer, index) => (
                    <div
                      key={index}
                      className={`mb-[0.7vw] flex w-full flex-row items-start justify-start text-sm text-[#333333] last:mb-0 ${answer.type === 'paragraph' ? 'indent-8' : ''} ${answer.type === 'list' ? 'pl-8' : ''}`}
                    >
                      {answer.type === 'list' && (
                        <div className="mr-1 flex size-5 flex-row items-center justify-center">
                          <div className="size-[6px] rounded-full bg-black"></div>
                        </div>
                      )}
                      {answer.content}
                    </div>
                  ))}
                </div>
              </AccordionContent>
            </AccordionItem>
          );
        })}
      </Accordion>
    </section>
  );
}
